import nsmWordmark from "@/assets/brand/nsm-wordmark-white.png";

export function Footer() {
  return (
    <footer className="mt-16 border-t border-nsm-border bg-nsm-surface/40">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 py-8 sm:flex-row lg:px-8">
        <div className="flex items-center gap-3">
          <img src={nsmWordmark} alt="Nathaniel School of Music" className="h-7 w-auto opacity-80" />
        </div>
        <div className="text-xs text-nsm-dim">
          Everything for Life · Interactive companion · © {new Date().getFullYear()} NSM
          {" · "}
          <a href="https://nathanielschool.com" className="underline hover:text-nsm-ink">Nathaniel School of Music</a>
          {" · "}
          <a href="https://apps.nathanielschool.com" className="underline hover:text-nsm-ink">More free music apps</a>
        </div>
      </div>
    </footer>
  );
}
